import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_35: DocMigration = {
  maxSchemaVersion: "0.0.35",
  apply(json: any) {
    if (json.viewerFilter) {
      const viewerFilter = json.viewerFilter;
      if (!viewerFilter.hasOwnProperty("floorAreas")) {
        viewerFilter["floorAreas"] = true;
      }
    }
    return json;
  },
};

export default migration_0_0_35;
